import { Component, input, Input, OnDestroy, OnInit, output } from '@angular/core';

import { AuthService } from '../authentication/auth.service';

import { SharedSettings } from '../models/shared-settings';

import { UsersService } from "../services/users.service";
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';

@Component({
    selector: '[theme-header]',
    templateUrl: './theme.header.component.html',
    standalone: false
})
export class ThemeHeaderComponent implements OnInit, OnDestroy {
    @Input() isPropak: boolean = false;
    @Input() isTestEnvironment: boolean = false;

    menuButtonClick = output<void>();
    menuVisible = input<boolean>(true);

    username: string | null = null;
    displayName: string = '';
    canImpersonate: boolean = false;
    showImpersonateDialog: boolean = false;
    impersonationUsername: string;

    subscriptions: Subscription[] = [];

    constructor(private authService: AuthService,
                private userService: UsersService,
                private settings: SharedSettings,
                private router: Router) {

    }

    ngOnInit(): void {
        this.subscriptions = [
            this.authService.getAccount().subscribe(user => {
                if (!!user) {
                    this.username = user.username;
                    this.displayName = user.name;
                }
                else {
                    this.username = null;
                    this.displayName = '';
                }
            }),

            this.authService.isUserInAnyRoles([ 'it', 'developers' ]).subscribe(isInRole => {
                this.canImpersonate = isInRole && !this.settings.isProduction;
            })
        ];
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    logout(): void {
        this.authService.logout();
    }

    openDialog() {
        this.showImpersonateDialog = true;

    }

    setImpersonation() {
        this.userService.ImpersonateUser(this.impersonationUsername).subscribe(u => {
            this.displayName = u.displayName;
            this.showImpersonateDialog = false;
            this.router.navigate(['/']).then(() => window.location.reload());
        }, () => this.showImpersonateDialog = false);
    }

    cancelImpersonation() {
        this.userService.CancelImpersonateUser().subscribe(_ => {
            this.showImpersonateDialog = false
            this.router.navigate(['/']).then(() => window.location.reload());
        })
    }
}
